import React, { Fragment } from 'react'
import { SwiperSlide } from 'swiper/react'

import { MyCard } from '../../MyCard'
import { Slider } from '../../../Slider'

export default function TeamsSlider({
  organizations,
  navigationNextRef,
  navigationPrevRef,
}) {
  const prefix = 'team'

  return (
    <Fragment>
      <Slider
        navigationPrevRef={navigationPrevRef}
        navigationNextRef={navigationNextRef}
      >
        {organizations &&
          organizations.map((organization, index) => {
            return (
              <SwiperSlide
                key={organization?.uuid || index}
                className="swiper-lazy"
              >
                <MyCard prefix={prefix} organization={organization} />
              </SwiperSlide>
            )
          })}
      </Slider>
    </Fragment>
  )
}
